export default "__VITE_ASSET__Brga$jGV__"